const GLB_MAGIC_BYTES = [0x67, 0x6c, 0x54, 0x46] as const

const hasGlbMagic = async (blob: Blob): Promise<boolean> => {
  if (blob.size < GLB_MAGIC_BYTES.length) return false

  const header = new Uint8Array(await blob.slice(0, GLB_MAGIC_BYTES.length).arrayBuffer())
  return GLB_MAGIC_BYTES.every((byte, index) => header[index] === byte)
}

/**
 * VRM(GLB) として最低限成立するバイナリかを判定する。
 */
export const isValidVrmBlob = async (blob: Blob): Promise<boolean> => {
  return hasGlbMagic(blob)
}

/**
 * VRM(GLB) 形式が不正な場合に例外を投げる。
 */
export const assertValidVrmBlob = async (blob: Blob, source: string): Promise<void> => {
  const valid = await isValidVrmBlob(blob)
  if (valid) return

  throw new Error(`invalid VRM blob from ${source}`)
}
